import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/es/integration/react'
import { configureStore } from 'app/configuration'
import { App } from 'app/App'
import { ConnectedIntlProvider } from 'shared/i18n/ConnectedIntlProvider'
import './polyfills'
import Modal from 'react-modal'
import { Twicpics } from '@twicpics/react'
import { twicPicsDomain } from 'app/common/utils'

declare var require: any

Twicpics({
    domain: twicPicsDomain,
    defaultParams: {
        anticipation: 0.5,
        maxDpr: 2,
        step: 50
    }
})

const bootApplication = () => {
    const { store, persistor } = configureStore()
    const root = document.getElementById('root')
    if (root) {
        Modal.setAppElement(root)
        ReactDOM.render(
            <Provider store={store}>
                <PersistGate persistor={persistor}>
                    <ConnectedIntlProvider>
                        <App />
                    </ConnectedIntlProvider>
                </PersistGate>
            </Provider>,
            root
        )
    }
}

if (!global.Intl) {
    Promise.all([import('intl'), import('intl/locale-data/jsonp/fr.js')]).then(
        () => {
            bootApplication()
        }
    )
} else {
    bootApplication()
}
